// Teksten van huishouden (sprint 4): boodschappen, recepten, weekmenu, voorraad en de
// kiosk-ingang Eten (docs/DESIGN.md 8.W13–8.W16, 8.K8). Je-vorm, korte zinnen, geen jargon.
export const foodNl = {
    nav: 'Eten',
    title: 'Eten',
    tabs: {
        shopping: 'Boodschappen',
        recipes: 'Recepten',
        menu: 'Weekmenu',
        pantry: 'Voorraad',
    },
    undo: 'Ongedaan maken',
    save: 'Opslaan',
    cancel: 'Annuleren',
    close: 'Sluiten',
    remove: 'Verwijderen',
    retry: 'Opnieuw proberen',
    errorLoad: 'Het laden lukte niet. Probeer het opnieuw.',
    errorSave: 'Opslaan lukte niet. Probeer het opnieuw.',
    categories: {
        produce: 'Groente en fruit',
        bakery: 'Brood en ontbijt',
        dairy: 'Zuivel en eieren',
        meat: 'Vlees en vis',
        pantry: 'Voorraadkast',
        drinks: 'Drinken',
        household: 'Huishouden',
        other: 'Overig',
    },
    units: {
        g: 'gram',
        kg: 'kilo',
        ml: 'ml',
        cl: 'cl',
        dl: 'dl',
        l: 'liter',
        el: 'eetlepel',
        tl: 'theelepel',
        kop: 'kopje',
        snuf: 'snufje',
        stuk: 'stuk',
        teen: 'teen',
        blik: 'blik',
        pak: 'pak',
        zak: 'zak',
        bos: 'bos',
        plak: 'plak',
        fles: 'fles',
        doos: 'doos',
        krop: 'krop',
        pot: 'pot',
        takje: 'takje',
        handje: 'handje',
        scheut: 'scheut',
    },
    shopping: {
        addLabel: 'Wat moet erbij?',
        addPlaceholder: 'Bijvoorbeeld 2 pak melk',
        add: 'Erbij',
        frequent: 'Vaak gekocht',
        inBasket: 'In je mandje ({count})',
        clearChecked: 'Wis afgevinkt',
        newList: 'Lijst',
        newListTitle: 'Nieuwe lijst',
        listName: 'Naam van de lijst',
        listNameHint: 'Bijvoorbeeld Markt of Drogist',
        listsLabel: 'Boodschappenlijsten',
        renameList: 'Lijst aanpassen',
        archiveList: 'Lijst verwijderen',
        listMenu: 'Meer voor deze lijst',
        archiveAsk: 'Lijst {name} verwijderen?',
        archiveHint: 'Wat erop staat gaat mee. Je kunt het meteen ongedaan maken.',
        archivedList: 'Lijst {name} verwijderd',
        lastList: 'De laatste lijst kan niet weg. Geef hem liever een andere naam.',
        emptyTitle: 'Alles is in huis',
        emptyBody: 'Zet hier wat op het lijstje; iedereen ziet het meteen.',
        added: '{name} staat erop',
        merged: '{name}: nu {amount}',
        removed: '{name} verwijderd',
        cleared: 'Afgevinkte boodschappen gewist',
        viaTablet: 'via de tablet',
        forRecipe: 'voor {title}',
        editItem: 'Boodschap aanpassen',
        name: 'Naam',
        amount: 'Hoeveelheid',
        unit: 'Eenheid',
        noUnit: 'Geen',
        note: 'Opmerking',
        icon: 'Pictogram',
        list: 'Lijst',
        check: '{name} afvinken',
        uncheck: '{name} terugzetten',
        addedBy: 'Toegevoegd door {name}',
    },
    recipes: {
        search: 'Zoek een recept',
        filterAll: 'Alles',
        filterOwn: 'Eigen',
        filterLibrary: 'Collectie',
        add: 'Recept',
        newTitle: 'Nieuw recept',
        editTitle: 'Recept aanpassen',
        modeManual: 'Zelf invullen',
        modeLink: 'Van een link',
        link: 'Link naar het recept',
        linkHint: 'Werkt met receptensites en met YouTube, TikTok en Instagram.',
        fetch: 'Ophalen',
        fetching: 'Recept ophalen…',
        name: 'Naam van het recept',
        description: 'Korte omschrijving',
        servings: 'Personen',
        minutes: 'Minuten',
        ingredients: 'Ingrediënten',
        ingredientsHint: 'Eén per regel, bijvoorbeeld 500 g gehakt',
        steps: 'Bereiding',
        stepsHint: 'Eén stap per regel',
        minutesShort: '{n} min',
        people: '{n} pers.',
        video: 'Video',
        needsIngredients: 'Voeg de ingrediënten toe',
        noResults: 'Geen recept gevonden',
        noResultsBody: 'Probeer een ander woord of voeg er zelf een toe.',
        emptyTitle: 'Nog geen recepten',
        emptyBody: 'Voeg je eerste recept toe, of haal er een op met een link.',
        toMenu: 'Op het menu',
        toList: 'Naar de lijst',
        edit: 'Bewerken',
        photo: 'Foto toevoegen',
        changePhoto: 'Andere foto',
        removePhoto: 'Foto weghalen',
        photoUploading: 'Foto uploaden…',
        photoTooLarge: 'Deze foto is te groot.',
        photoUnsupported: 'Dit bestand is geen foto die we kunnen gebruiken.',
        archive: 'Verbergen',
        archived: '{title} verborgen',
        openVideo: 'Bekijk de video',
        openSource: 'Naar de website',
        back: 'Alle recepten',
        fromLibrary: 'Uit de collectie',
        ingredientsEmpty: 'Nog geen ingrediënten.',
        stepsEmpty: 'Nog geen bereiding.',
        toListTitle: 'Naar de boodschappenlijst',
        toListBody: 'Wat al in de voorraad staat of altijd in huis is, staat uit.',
        toListDo: 'Op de lijst zetten',
        toListDone: '{count} op {list}',
        toListMerged: '{count} op {list}, {merged} samengevoegd',
        toListNothing: 'Alles staat al op de lijst of is in huis.',
        staple: 'altijd in huis',
        inPantry: 'in huis',
        pickDayTitle: 'Op het menu zetten',
        pickDay: 'Kies een dag',
        planned: '{title} staat op {day}',
        created: '{title} toegevoegd',
        imported: '{title} opgehaald',
        importErrors: {
            no_recipe_found: 'Op deze pagina staat geen recept dat we kunnen lezen. Vul het zelf in?',
            blocked_address: 'Deze link kunnen we niet openen.',
            invalid_url: 'Gebruik een beveiligde link (die met https begint).',
            too_large: 'Deze pagina is te groot om te lezen.',
            timeout: 'De website reageerde niet op tijd. Probeer het later nog eens.',
            fetch_failed: 'De website is nu niet bereikbaar.',
        },
        fillManually: 'Zelf invullen',
    },
    menu: {
        week: 'Week {week}',
        range: '{from} – {to}',
        thisWeek: 'Deze week',
        prev: 'Vorige week',
        next: 'Volgende week',
        allToList: 'Alles op de lijst',
        choose: 'Kies',
        chooseFor: 'Kies wat we eten op {day}',
        dragHint: 'Sleep een recept naar een dag',
        tapHint: 'Tik op + Kies bij een dag',
        moreRecipes: 'Meer recepten ({count})',
        freeSection: 'Of iets anders, bijvoorbeeld Uit eten',
        freeSave: 'Op het menu',
        pickRecipe: 'Kies een recept',
        shelf: 'Recepten',
        removeMeal: '{title} van het menu halen',
        removed: '{title} van het menu gehaald',
        moved: 'Verplaatst naar {day}',
        freeText: 'Of typ iets anders',
        freePlaceholder: 'Bijvoorbeeld Uit eten',
        emptyTitle: 'Nog niets op het menu',
        emptyBody: 'Sleep een recept naar een dag.',
        today: 'vandaag',
        nothingToList: 'Er staan nog geen recepten op het menu deze week.',
        servings: '{n} pers.',
    },
    pantry: {
        addLabel: 'Wat hebben we in huis?',
        addPlaceholder: 'Bijvoorbeeld 1 kg aardappelen',
        add: 'Erbij',
        listLabel: 'In de voorraad',
        removeItem: '{name} uit de voorraad halen',
        removed: '{name} uit de voorraad',
        suggestionsTitle: 'Wat kunnen we maken?',
        allInHouse: 'Alles in huis',
        stillNeeded: 'Nog nodig: {items}',
        emptyTitle: 'Nog niets in de voorraad',
        emptyBody: 'Zet erin wat je hebt; wij bedenken wat je kunt maken.',
        noSuggestions: 'Nog geen recept waarvoor genoeg in huis is.',
        staples: 'Zout, peper, olie en water tellen als altijd in huis.',
    },
    kiosk: {
        entry: 'Eten',
        back: 'Terug',
        tonight: 'Vanavond eten we',
        nothingPlanned: 'Nog niets gepland',
        nothingPlannedBody: 'Papa of mama kiest in de app.',
        tomorrow: 'Morgen',
        add: 'Erbij',
        addTitle: 'Wat moet erbij?',
        close: 'Sluiten',
        added: '{name} staat erop',
        oops: 'Oeps',
        emptyTitle: 'Alles is in huis',
        check: '{name}: in het mandje?',
        // UX-ronde bord: een regel in het mandje met één tik terugzetten.
        backOnList: '{name}: terug op de lijst',
        confirm: 'In het mandje',
        shopping: 'Boodschappen',
        week: 'Deze week',
        inBasket: '{name} in het mandje',
        more: 'Meer boodschappen',
        // Polish w4 ronde 2: samengevoegd (geen Oeps), zelf typen, meer tegels.
        alreadyOn: '{name} stond er al op',
        typeOwn: 'Typ zelf',
        typeLabel: 'Wat moet erbij?',
        typePlaceholder: 'Bijv. hagelslag',
        typeAdd: 'Erbij',
        closeTyping: 'Terug naar de plaatjes',
        moreTiles: 'Meer plaatjes',
    },
};
//# sourceMappingURL=food.nl.js.map